import { render, staticRenderFns } from "./characterProfile.vue?vue&type=template&id=08989616&scoped=true"
import script from "./characterProfile.vue?vue&type=script&lang=js"
export * from "./characterProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08989616",
  null
  
)

export default component.exports